const getTestId = (testId, component) => testId && component ? `${testId}-${component}` : undefined;

export { getTestId };
